import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FAQCategory } from '../types';

interface ChatbotState {
  isOpen: boolean;
  persistedCategories: {
    technology: FAQCategory[];
    subscriber: FAQCategory[];
  };
  lastUpdated: string | null;
}

const initialState: ChatbotState = {
  isOpen: false,
  persistedCategories: {
    technology: [],
    subscriber: [],
  },
  lastUpdated: null,
};

const chatbotSlice = createSlice({
  name: 'chatbot',
  initialState,
  reducers: {
    toggleChatbot: (state) => {
      state.isOpen = !state.isOpen;
    },
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setPersistedCategories: (state, action: PayloadAction<{ type: 'technology' | 'subscriber'; data: FAQCategory[] }>) => {
      const { type, data } = action.payload;
      
      // Safety check for legacy persisted state that might still be an array
      if (Array.isArray(state.persistedCategories)) {
        state.persistedCategories = {
          technology: [],
          subscriber: [],
        };
      }
      
      state.persistedCategories[type] = data;
      state.lastUpdated = new Date().toISOString();
    },
  },
});

export const { toggleChatbot, setIsOpen, setPersistedCategories } = chatbotSlice.actions;
export default chatbotSlice.reducer;
